export default __webpack_public_path__ + "static/media/featherball.744af0de.png";